import { createStore } from 'jotai'
import { createContext, useContext } from 'react'

export type DesignGalleryStore = ReturnType<typeof createStore>

export const DesignGalleryStoreContext = createContext<DesignGalleryStore | null>(null)

export function createDesignGalleryStore(): DesignGalleryStore {
	return createStore()
}

export function useDesignGalleryStore(): DesignGalleryStore {
	const store = useContext(DesignGalleryStoreContext)
	if (!store) {
		throw new Error('useDesignGalleryStore must be used within a DesignGalleryManager')
	}
	return store
}
